import TCaptcha from '@/utils/TCaptcha'

export default {
  data(){
    return{
      ctoken: {
        captcha: '',
        ua: navigator.userAgent,
      }
    }
  },
  methods:{
    async scrollyz() {
      try {
        const { data } = await this.$http.get('/freeadmissionswitch')
        if (data.data.free_admission_switch == 0) {
          this.search()
        }else if(data.data.free_admission_switch == 1){
          const res = await this.$http.get('/vercode')
          if(res.data.code == 0){
            if(res.data.data[0].api){
              const tcaptcha = new TCaptcha()
              tcaptcha.getTCaptcha(data=>{
                this.ctoken.captcha = data.data[0]
                this.search()
              })
              // 阿里云滑块注释 ↓↓↓
              // this.dialogVisible = true;
              // if (this.nc) {
              //   return this.nc.reset();
              // }
              // var that = this;
              // // 实例化nc
              // AWSC.use("nc", function (state, module) {
              //   // 初始化
              //   that.nc = module.init({
              //     // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
              //     appkey: "FFFF0N00000000009A78",
              //     //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
              //     scene: "nc_other",
              //     // 声明滑动验证需要渲染的目标ID。
              //     renderTo: "scrollyz",
              //     // test:module.TEST_BLOCK,
              //     //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
              //     success: function (data) {
              //       that.$http.post("/captcha", {
              //         csessionId: data.sessionId,
              //         sig: data.sig,
              //         ctoken: data.token,
              //       }).then((res) => {
              //         if (res.data.status == "error") return this.$store.commit('noticeErrorMsg',"验证失败,请重试")
              //         that.ctoken.captcha = res.data.data[0];
              //         that.search()
              //       });
              //       that.dialogVisible = false;
              //     },
              //     // 滑动验证失败时触发该回调参数。
              //     fail: function (failCode) {},
              //     // 验证码加载出现异常时触发该回调参数。
              //     error: function (errorCode) {
              //       this.dialogVisible = false;
              //       this.$store.commit('noticeErrorMsg',"获取验证码失败")
              //     },
              //   });
              // });
            }else{
              const result = await this.$http.post("/captcha",{ type: 'api' })
              if(result.data.status == 'success'){
                this.ctoken.captcha = result.data.data[0]
                this.search()
              }else{
                this.$store.commit('noticeErrorMsg',result.data.msg)
              }
            }
          }else{
            this.$store.commit('noticeErrorMsg',res.data.msg)
          }
        }else{
          this.$store.commit('noticeErrorMsg',data.data.msg)
        }
      }catch (err){
        this.$store.commit('noticeErrorMsg','网络异常,请稍后重试')
      }
    }
  }
}
